import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dominantSpeaker" }
const _hoisted_2 = { class: "avatar" }
const _hoisted_3 = { class: "participantName" }

import { ProfileAvatarSizeEnum } from "@/types/avatar";
import { RoomParticipant } from "@/types/call";
import CallAvatar from "../CallAvatar/CallAvatar.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import MediaDisplayControl from "../MediaOutputControl/MediaDisplayControl.vue";
interface Props {
  roomParticipant: RoomParticipant | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CallDominantSpeaker',
  props: {
    roomParticipant: { default: null }
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const participantText = computed(() => {
  let text = "";
  if (!props.roomParticipant?.isConnected) {
    text += `${t("call.establishingCall")} `;
  }
  text += props.roomParticipant?.user.name;
  return text;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CallAvatar, {
        size: _unref(ProfileAvatarSizeEnum).ExtraBig,
        src: _ctx.roomParticipant?.user.picture,
        "is-connected": !!props.roomParticipant?.isConnected
      }, null, 8, ["size", "src", "is-connected"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(participantText.value), 1)
    ]),
    (_ctx.roomParticipant?.participant?.identity)
      ? (_openBlock(), _createBlock(MediaDisplayControl, {
          key: _ctx.roomParticipant?.participant?.identity,
          "room-participant": _ctx.roomParticipant,
          class: "dominantSpeakerRef"
        }, null, 8, ["room-participant"]))
      : _createCommentVNode("", true)
  ]))
}
}

})